var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "d-flex justify-content-center",
      class: { "align-items-center": _vm.centerText }
    },
    [
      _vm.showChart
        ? _c(
            "div",
            {
              staticClass: "d-flex align-items-center justify-content-center",
              staticStyle: { width: "50%" }
            },
            [
              _vm.size
                ? _c("apexchart", {
                    attrs: {
                      type: "donut",
                      height: _vm.size,
                      width: _vm.size,
                      options: _vm.formatOpts,
                      series: _vm.formatData
                    }
                  })
                : _vm._e(),
              !_vm.size
                ? _c("apexchart", {
                    attrs: {
                      type: "donut",
                      options: _vm.formatOpts,
                      series: _vm.formatData
                    }
                  })
                : _vm._e()
            ],
            1
          )
        : _vm._e(),
      _c(
        "div",
        {
          staticClass: "d-flex flex-column",
          class: { "justify-content-center": _vm.centerText },
          staticStyle: { "min-width": "30%" }
        },
        [
          _c(
            "v-simple-table",
            {
              staticClass: "tabela-liquidez",
              staticStyle: { background: "transparent", width: "100%" },
              attrs: { dense: "" }
            },
            [
              [
                _c(
                  "tbody",
                  [
                    _vm._l(_vm.values, function(liq, i) {
                      return [
                        _vm.getNumber(liq.pl)
                          ? _c("tr", { key: liq.name, staticClass: "mb-1" }, [
                              _c("td", [
                                _c(
                                  "div",
                                  { staticClass: "d-flex align-items-center" },
                                  [
                                    _vm.showChart
                                      ? _c("v-sheet", {
                                          style: {
                                            "background-color":
                                              _vm.Color.paleta[i]
                                          },
                                          attrs: { height: "20", width: "5" }
                                        })
                                      : _vm._e(),
                                    _c("p", { staticClass: "ml-1 mr-5 mb-0" }, [
                                      _vm._v(" " + _vm._s(liq.name) + " ")
                                    ])
                                  ],
                                  1
                                )
                              ]),
                              _c("td", [
                                _c(
                                  "p",
                                  {
                                    staticClass:
                                      "text-bold mb-0 mr-2 text-right"
                                  },
                                  [
                                    _vm.showPL
                                      ? _c(
                                          "span",
                                          {
                                            staticClass: "text-color-400 mr-2"
                                          },
                                          [_vm._v(" " + _vm._s(liq.pl) + " ")]
                                        )
                                      : _vm._e(),
                                    _vm._v(" " + _vm._s(liq.weight) + " ")
                                  ]
                                )
                              ])
                            ])
                          : _vm._e()
                      ]
                    })
                  ],
                  2
                )
              ]
            ],
            2
          )
        ],
        1
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }